import gameAssets from '@themed-assets'
import React from 'react'
import styles from './PlayerPositionIcon.module.css'
import { motion } from 'motion/react'

export default function PlayerPositionIcon({ isSmallBlind, isBigBlind, isDealer, maxPlayers, clientChairIndex, isSeatedOut, gameDefinition }) {
  const getPositionClass = () => {
    // Generic logic for other player counts
    const halfPoint = Math.floor(maxPlayers / 2);
    if (clientChairIndex === 0) return styles.bottom;
    if (clientChairIndex < halfPoint) return styles.left;
    if (clientChairIndex === halfPoint) return styles.top;
    return styles.right;
  };

  if ((isSmallBlind || isBigBlind) && !isSeatedOut && !isDealer) {
    return null;
  }

  if (isSeatedOut) {
    return (
      <div className={`${styles.playerPositionIconContainer} ${styles.coffeePosition}`}>
        <img src={gameAssets.coffee} alt="coffee" className={styles.coffeeIcon} />
      </div>
    )
  }

  return isDealer ? (
    <div className={`${styles.playerPositionIconContainer} ${getPositionClass()}`}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className={styles.playerPositionIcon}>
        {
          isDealer ? 'D' : isSmallBlind ? 'SB' : isBigBlind ? 'BB' : null
        }
      </motion.div>
    </div>
  ) : null;
}